import { render, staticRenderFns } from "./DashboardMapsClienteRFC.vue?vue&type=template&id=321a3c91&scoped=true&"
import script from "./DashboardMapsClienteRFC.vue?vue&type=script&lang=js&"
export * from "./DashboardMapsClienteRFC.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMapsClienteRFC.vue?vue&type=style&index=0&id=321a3c91&scoped=true&lang=css&"
import style1 from "./DashboardMapsClienteRFC.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a3c91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
